export const es = {
    common: {
        home: 'Inicio',
        search: 'Buscar',
        guest: 'Invitado',
        logout: 'Cerrar sesión',
        toggleTheme: 'Cambiar tema',
        toggleSidebar: 'Alternar barra lateral',
        close: 'Cerrar',
        more: 'Más',
        saveChanges: 'Guardar cambios',
        cancel: 'Cancelar',
        delete: 'Eliminar',
        export: 'Exportar',
        loading: 'Cargando...',
        activity: 'Actividad',
        confirm: 'Confirmar',
        noResultsFound: 'No se encontraron resultados.',
        justNow: 'justo ahora',
        minutesAgo: 'hace {{count}} min',
        hoursAgo: 'hace {{count}} h',
        daysAgo: 'hace {{count}} d',
        pagination: {
            previous: 'Anterior',
            next: 'Siguiente',
            page: 'Página {{page}} de {{totalPages}}',
            summary: 'Página {{page}} de {{totalPages}} · mostrando {{count}} de {{total}} elementos'
        }
    },
    notFound: {
        title: '404',
        heading: 'Página no encontrada',
        description: 'La página que buscas no existe o fue movida.',
        cta: 'Ir al panel'
    },
    routeError: {
        heading: 'Algo salió mal',
        description: 'El enrutador encontró un error inesperado al cargar esta página.',
        cta: 'Volver al panel'
    },
    startup: {
        preparingSessionTitle: 'Preparando tu sesión',
        preparingSessionDescription:
            'Estamos validando la autenticación antes de que el entorno de trabajo sea interactivo.',
        preparingSessionStatus: 'Comprobando autenticación',
        loadingDataTitle: 'Cargando datos de inicio',
        loadingDataDescription:
            'Obteniendo el contexto necesario de cuenta y organización para este espacio de trabajo.',
        loadingDataStatus: 'Cargando datos de inicio',
        waitHint:
            'Esta pantalla permanece visible hasta que el inicio esté completamente listo para que la navegación protegida no aparezca antes de tiempo.',
        errorTitle: 'No pudimos completar el inicio',
        errorDescription: 'Falló una solicitud de inicio recuperable. Vuelve a intentarlo sin recargar toda la página.',
        errorFallback: 'Error inesperado de inicio.',
        retry: 'Reintentar inicio',
        retryHint: 'Si el problema persiste, revisa la conectividad del backend y el estado de autenticación.'
    },
    appShell: {
        onboardingCheck: {
            failureTitle: 'Todavía no pudimos verificar el onboarding',
            failureDescription:
                'Las acciones del espacio de trabajo permanecen en pausa mientras repetimos la verificación de onboarding de la organización.',
            retry: 'Reintentar verificación de onboarding'
        }
    },
    dashboardWelcome: {
        badge: 'Bienvenida inicial del panel',
        title: 'Ya estás dentro. Aquí está tu scaffold posterior al checkout.',
        description:
            'Estado del panel simulado solo en frontend para nuevos espacios de trabajo. La creación real de claves API, las plantillas iniciales y la salida de consola en vivo llegarán después.',
        continueAction: 'Continuar al espacio de trabajo',
        apiKeyTitle: 'Scaffold de clave API',
        apiKeyDescription:
            'Tarjeta placeholder para la primera clave del proyecto, permisos, acción de copia y metadatos de último uso.',
        primaryKey: 'Clave principal',
        createApiKey: 'Crear clave API',
        quickstartTitle: 'Scaffold de inicio rápido',
        quickstartDescription:
            'La pestaña predeterminada sigue el modo de construcción del onboarding. Por ahora los snippets son placeholders simulados.',
        recommendedTemplateTitle: 'Plantilla recomendada',
        recommendedTemplateDescription:
            'Área placeholder para sugerencias de plantillas basadas en objetivos de onboarding y modo de construcción.',
        starterPipelineTitle: 'Pipeline de contenido inicial',
        starterPipelineDescription:
            'Aquí se mostrarán tarjetas de configuración sugeridas, prompts iniciales y cableado de fuentes precompletado.',
        applyTemplate: 'Aplicar plantilla',
        consoleTitle: 'Consola / área de respuesta',
        consoleDescription: 'Placeholder para respuestas del SDK, trazas de solicitudes y la primera salida correcta.',
        consoleStatus: 'Estado: esperando integración en vivo con backend…',
        consoleReady: 'Panel de respuesta simulada listo'
    },
    home: {
        title: 'Inicio',
        unlimited: 'Ilimitado',
        apiUsage: '// Uso de API',
        publishJobsPerDay: 'Trabajos de publicación por día',
        last7Days: 'Últimos 7 días',
        jobsOnDate: '{{count}} trabajos de publicación el {{date}}',
        noJobsLast7Days: 'No hay trabajos de publicación en los últimos 7 días',
        usageUnavailable: 'Los datos de uso no están disponibles',
        postsUsed: '@{{account}} · {{used}} / {{limit}} publicaciones usadas',
        resetsOn: 'se restablece el {{date}}',
        noQuotaPeriod: 'Sin período de cuota',
        gettingStarted: '// Primeros pasos',
        recentJobs: '// Trabajos recientes',
        loadingRecentJobs: 'Cargando trabajos recientes…',
        recentJobsUnavailable: 'Los trabajos recientes no están disponibles.',
        noPublishingJobs: 'Aún no hay trabajos de publicación.',
        untitledPost: 'Publicación sin título',
        activeKeyCount: '{{count}} clave API activa',
        loadingDescription: 'Cargando el resumen de tu organización…',
        stats: {
            connectedAccounts: 'Cuentas conectadas',
            sourcesInPlan: '{{count}} fuentes incluidas en tu plan',
            postsLeft: 'Publicaciones restantes este período',
            postsAcrossAccounts: '{{count}} publicaciones en cuentas conectadas',
            scheduledJobs: 'Trabajos programados'
        },
        checklist: {
            createOrganization: 'Crea tu organización',
            connectSocialAccount: 'Conecta una cuenta social',
            socialAccountDetail: 'Instagram o X',
            createApiKey: 'Crea una clave API',
            apiKeyScopes: 'publishing:read · publishing:publish',
            publishFirstPost: 'Publica tu primera publicación',
            publishEndpoint: 'POST /publishing/jobs'
        },
        actions: {
            createPost: 'Crear publicación',
            start: 'Empezar',
            viewAll: 'Ver todo',
            viewApiDocs: 'Ver documentación de API',
            createApiKey: 'Crear clave API',
            connectAccount: 'Conectar una cuenta',
            viewInsights: 'Ver insights',
            inviteMember: 'Invitar a un miembro'
        },
        quickActions: '// Acciones rápidas',
        quickActionsTitle: 'Crea con tu organización',
        quickActionsDescription: 'Empieza con las herramientas que ya están conectadas a tu espacio de trabajo.',
        status: { published: 'Publicado', processing: 'Procesando', scheduled: 'Programado', other: 'Desconocido' }
    },
    settings: {
        pageTitle: 'Configuración',
        pageDescription: 'Administra las preferencias de tu espacio de trabajo.',
        general: 'General',
        notifications: 'Notificaciones',
        danger: 'Zona peligrosa',
        billing: {
            tab: 'Facturación',
            title: 'Facturación',
            description: 'Revisa el estado actual de facturación de {{organizationName}}.',
            currentPlanEyebrow: '// plan actual',
            entitlementsEyebrow: '// permisos',
            noOrganizationTitle: 'No hay una organización seleccionada',
            noOrganizationDescription:
                'Selecciona o crea una organización para ver los detalles de suscripción y facturación.',
            portalFooter:
                'La facturación se gestiona con Stripe. Administra tarjetas y facturas en el portal del cliente.',
            lifetimeBadge: 'Lifetime',
            lifetimeFooter:
                'Esta organización tiene un plan lifetime y no se factura con Stripe, por lo que no hay tarjetas ni facturas que administrar. Contacta con invisibleapi para cambiar el plan.',
            cancelAtPeriodEndNotice:
                'Esta suscripción está configurada para cancelarse al final del período de facturación actual.',
            manageBillingDisabledNoOrganization: 'Primero crea o selecciona una organización.',
            manageBillingDisabledNoCustomer: 'Esta organización todavía no tiene un cliente de Stripe.',
            manageBillingDisabledLifetime:
                'Un plan lifetime no se factura con Stripe, así que no tiene portal del cliente.',
            priceAfterTrialValue: '{{price}}/{{interval}}',
            postsLimitValue: '{{count}} publicaciones por cuenta conectada y período.',
            noActivePlanTitle: 'Sin plan activo',
            capabilitiesTitle: 'Capacidades',
            limitsTitle: 'Límites',
            emptyBillingState: 'Todavía no hay estado de facturación disponible para la organización seleccionada.',
            emptyCapabilities: 'No se devolvieron datos de capacidades.',
            emptyLimits: 'No se devolvieron datos de límites.',
            fields: {
                subscriptionStatus: 'Estado de la suscripción',
                billingInterval: 'Intervalo de facturación',
                quantity: 'Fuentes (cantidad)',
                priceAfterTrial: 'Precio después de la prueba',
                trialEndsAt: 'La prueba termina',
                currentPeriod: 'Período actual',
                accessPeriod: 'Período de acceso',
                cancelAtPeriodEnd: 'Cancelar al final del período'
            },
            subscriptionStatuses: {
                active: 'Activa',
                trialing: 'En prueba',
                incomplete: 'Incompleta',
                incomplete_expired: 'Incompleta expirada',
                past_due: 'Vencida',
                canceled: 'Cancelada',
                unpaid: 'Impaga',
                paused: 'Pausada'
            },
            billingIntervals: {
                monthly: 'Mensual',
                yearly: 'Anual'
            },
            boolean: {
                yes: 'Sí',
                no: 'No'
            },
            errors: {
                generic: 'No se pudieron cargar los datos de facturación.'
            },
            checkout: {
                loading: 'Redirigiendo…'
            },
            customerPortal: {
                open: 'Administrar facturación',
                loading: 'Abriendo portal…'
            },
            returnState: {
                success: 'Se completó el checkout de facturación. Actualizando estado de facturación…',
                cancel: 'Se canceló el checkout de facturación.',
                portalReturn: 'Regresaste del portal de facturación. Actualizando estado de facturación…'
            }
        },
        generalTitle: 'Configuración general',
        generalDescription: 'Configura el nombre de tu espacio de trabajo y las preferencias básicas.',
        workspaceName: 'Nombre de la organización',
        workspaceSlug: 'Slug de la organización',
        timezone: 'Zona horaria',
        settingsSaved: 'Configuración guardada',
        notificationsSaved: 'Preferencias de notificación guardadas',
        notificationsTitle: 'Preferencias de notificación',
        notificationsDescription: 'Elige cómo y cuándo quieres recibir notificaciones.',
        emailNotifications: 'Notificaciones por correo',
        emailNotificationsDescription: 'Recibe actualizaciones por correo sobre la actividad del espacio de trabajo.',
        pushNotifications: 'Notificaciones push',
        pushNotificationsDescription: 'Recibe notificaciones en tu navegador sobre eventos importantes.',
        weeklyDigest: 'Resumen semanal',
        weeklyDigestDescription: 'Recibe un resumen semanal de la actividad del espacio de trabajo.',
        dangerTitle: 'Zona peligrosa',
        dangerDescription: 'Acciones irreversibles que afectan a tu espacio de trabajo.',
        deleteWorkspace: 'Eliminar organización',
        deleteWorkspaceDescription: 'Elimina permanentemente esta organización y todos sus datos.',
        deleteUnavailable: 'Esta acción no está disponible en la plantilla.',
        exportData: 'Exportar datos',
        exportDataDescription: 'Descarga una exportación completa de los datos de tu espacio de trabajo.',
        exportStarted: 'La exportación comenzó; se te notificará cuando esté lista.',
        savePreferences: 'Guardar preferencias'
    },
    accountDetails: {
        pageTitle: 'Detalles de cuenta',
        pageDescription: 'Administra los datos de tu perfil y las acciones de seguridad de tu cuenta.',
        loadErrorTitle: 'No se pudieron cargar los detalles de cuenta',
        retry: 'Reintentar',
        managedBadge: 'Administrado centralmente',
        readOnlyBadge: 'Solo lectura',
        emptyValue: 'No definido',
        fields: {
            firstName: 'Nombre',
            lastName: 'Apellido',
            username: 'Nombre de usuario',
            email: 'Correo electrónico'
        },
        personalInfo: {
            title: 'Información personal',
            description: 'Actualiza los campos de perfil que se pueden editar para esta cuenta.',
            sourceHint:
                'El nombre de usuario y el correo vienen de tus datos de inicio de sesión y no se pueden editar aquí.',
            saving: 'Guardando...',
            reset: 'Restablecer cambios',
            saveSuccessToast: 'Detalles de cuenta guardados.',
            validationErrorToast: 'Revisa los campos marcados e inténtalo de nuevo.'
        },
        security: {
            title: 'Autenticación y seguridad',
            description:
                'Inicia flujos de seguridad de la cuenta mediante acciones del backend. El acceso de administrador nunca llega al navegador.',
            emailFlowBadge: 'Flujo seguro por correo',
            password: {
                title: 'Autenticación básica',
                description:
                    'Envíate el correo de actualización de contraseña y completa el cambio desde el flujo seguro por correo.',
                methodLabel: 'Método de actualización de contraseña',
                methodValue: 'Flujo seguro por correo',
                action: 'Enviar correo para actualizar contraseña',
                sending: 'Enviando correo...',
                successToast: 'Correo de actualización de contraseña solicitado. Revisa tu bandeja de entrada.',
                successInline:
                    'Correo solicitado. Revisa tu bandeja de entrada para continuar con el flujo de actualización de contraseña.'
            },
            twoFactor: {
                title: 'Autenticación de dos factores',
                description: 'Envíate el correo de configuración y configura una app autenticadora desde ese flujo.',
                methodLabel: 'Método de configuración de dos factores',
                methodValue: 'Flujo seguro por correo',
                action: 'Enviar correo de configuración 2FA',
                sending: 'Enviando correo...',
                successToast: 'Correo de configuración 2FA solicitado. Revisa tu bandeja de entrada.',
                successInline: 'Correo solicitado. Revisa tu bandeja de entrada para configurar 2FA.'
            }
        }
    },
    sidebar: {
        appName: 'Aplicación SaaS',
        workspace: 'Organización',
        login: 'Iniciar sesión',
        logout: 'Cerrar sesión',
        signedIn: 'Sesión iniciada',
        openSignIn: 'Abrir inicio de sesión',
        account: 'Cuenta',
        accountDetails: 'Detalles de cuenta',
        organizationMenu: 'Organizaciones',
        organizations: 'Organizaciones',
        currentOrganization: 'Actual',
        noOrganization: 'Todavía no hay organización',
        language: 'Idioma',
        languageSelector: 'Elegir idioma',
        languages: {
            en: 'Inglés',
            de: 'Alemán',
            es: 'Español',
            fr: 'Francés',
            mk: 'Macedonio',
            jp: 'Japonés'
        }
    },
    nav: {
        home: 'Inicio',
        organizations: 'Organizaciones',
        socialAccounts: 'Cuentas sociales',
        members: 'Miembros',
        invitations: 'Invitaciones',
        publishing: 'Publicación',
        insights: 'Estadísticas',
        apiKeys: 'Claves API',
        apiDocs: 'Documentación API',
        settings: 'Configuración',
        pricing: 'Precios',
        content: 'Contenido',
        audience: 'Audiencia',
        advancedQuery: 'Consulta avanzada',
        main: 'Principal'
    },
    publishing: {
        pageTitle: 'Publicación',
        pageDescription:
            'Revisa los trabajos de publicación de {{organizationName}} y su estado de entrega más reciente.',
        emptyOrganizationDescription:
            'Selecciona o crea una organización para empezar a revisar trabajos de publicación.',
        empty: 'Todavía no se encontraron trabajos de publicación.',
        refreshAction: 'Recargar trabajos',
        refreshDescription: 'Vuelve a solicitar al servidor los trabajos de publicación más recientes.',
        deliveryRecordsTitle: 'Qué significan los registros de entrega',
        deliveryRecordsDescription:
            'Cada registro de entrega representa un intento o resultado de entrega específico de una plataforma para una cuenta social seleccionada. Úsalo para ver qué ocurrió en cada destino.',
        scheduledFor: 'Programado para {{value}}',
        pagination: {
            previous: 'Anterior',
            next: 'Siguiente',
            page: 'Página {{page}}',
            summary: 'Página {{page}} · mostrando {{count}} trabajos (hasta {{perPage}} por página)',
            summaryCompact: '{{count}} trabajos · Página {{page}} de {{totalPages}}'
        },
        createAction: 'Crear publicación',
        subscriptionInactiveDescription:
            'Las publicaciones nuevas y los reintentos de trabajos fallidos quedan pausados hasta renovar la suscripción de esta organización.',
        previewAction: 'Vista previa',
        previewPostAction: 'Vista previa de la publicación',
        actionsMenuLabel: 'Abrir menú de acciones',
        viewDetailsAction: 'Ver detalles',
        copyJobIdAction: 'Copiar ID del trabajo',
        jobIdCopied: 'ID del trabajo copiado.',
        retryAction: 'Reintentar',
        cancelAction: 'Cancelar',
        retryUnavailable: 'Reintentar todavía no está disponible desde la lista de publicaciones.',
        cancelUnavailable: 'Cancelar todavía no está disponible desde la lista de publicaciones.',
        emptyStateTitle: 'Aún no hay trabajos de publicación',
        noCaptionShort: 'Sin texto',
        technicalDetailsAction: 'Detalles técnicos',
        technicalDetailsTitle: 'Detalles técnicos del trabajo de publicación',
        technicalDetailsDescription:
            'Inspecciona la carga útil bruta de publicación y los detalles de entrega de este trabajo.',
        previewTitle: 'Vista previa del trabajo de publicación',
        previewDescription: 'Inspecciona el estado guardado más reciente de este trabajo de publicación.',
        previewLoading: 'Cargando los detalles del trabajo de publicación…',
        instagram: {
            follow: 'Seguir',
            mediaAlt: 'Contenido multimedia de vista previa de Instagram',
            multiAsset: '{{count}} elementos',
            commentPlaceholder: 'Añade un comentario…',
            justNow: 'justo ahora'
        },
        noCaption: 'No se proporcionó texto.',
        noMediaItems: 'No se adjuntaron elementos multimedia a este trabajo de publicación.',
        noDeliveries: 'Todavía no hay registros de entrega disponibles para este trabajo de publicación.',
        failureTitle: 'Detalles del error',
        mediaItemsCount: '{{count}} elementos multimedia',
        deliveriesCount: '{{count}} registros de entrega',
        columns: {
            status: 'Estado',
            caption: 'Texto',
            targets: 'Entregas',
            createdAt: 'Creado',
            publishedAt: 'Publicado',
            actions: 'Acciones',
            actionsDescription: 'Abre la vista previa y de detalles de ese trabajo de publicación.'
        },
        fields: {
            status: 'Estado',
            createdAt: 'Creado el',
            updatedAt: 'Actualizado el',
            publishedAt: 'Publicado el',
            caption: 'Texto',
            firstComment: 'Primer comentario',
            requestedPublishAt: 'Programado para',
            mediaItems: 'Elementos multimedia',
            captionHelp: 'Mantén el texto claro y listo para la plataforma. Puedes revisarlo todo antes de enviarlo.',
            firstCommentHelp:
                'Opcional. Se publica después del contenido principal si la plataforma de destino lo permite.',
            mediaType: 'Tipo de medio',
            sourceUrl: 'URL de origen',
            publicFetchUrl: 'URL pública de acceso',
            altText: 'Texto alternativo',
            deliveries: 'Entregas',
            failureCode: 'Código de error',
            failureMessage: 'Mensaje de error'
        },
        status: {
            pending: 'Pendiente',
            queued: 'En cola',
            scheduled: 'Programado',
            processing: 'Procesando',
            published: 'Publicado',
            failed: 'Falló',
            canceled: 'Cancelado'
        }
    },

    publishingComposer: {
        pageTitle: 'Crear publicación',
        pageDescription: 'Crea un trabajo de publicación para {{organizationName}} y envíalo al flujo de publicación.',
        backToList: 'Volver a publicación',
        emptyOrganizationTitle: 'No hay una organización seleccionada',
        emptyOrganizationDescription: 'Selecciona o crea una organización antes de crear un trabajo de publicación.',
        publishTimeHint: 'Elige si esta publicación debe salir ahora o en una hora local programada.',
        localTimezoneHint: 'La hora programada usa tu zona horaria local actual.',
        connectAccountsAction: 'Abrir cuentas sociales',
        platformHint:
            'Elige dónde debe publicarse esta entrada. Instagram y X pueden publicar cuando hay una cuenta conectada activa disponible.',
        socialAccountHint: 'Selecciona la cuenta social conectada que debe recibir esta publicación.',
        socialAccountAutoSelected: 'Tu única cuenta conectada elegible se ha preseleccionado automáticamente.',
        selectSocialAccountAction: 'Seleccionar una cuenta social',
        selectedAccountsSummary: '{{count}} cuentas seleccionadas',
        selectedPlatformsLabel: 'Se publicará en',
        limits: {
            checking: 'Comprobando el uso de publicaciones…',
            remaining: 'Quedan {{count}} publicaciones en este período',
            exhausted: 'Límite alcanzado para este período',
            exhaustedWithReset: 'Límite alcanzado. Se restablece el {{resetAt}}',
            selectedExhaustedWarning:
                '{{account}} no tiene cupo de publicación disponible. Se restablece el {{resetAt}}.',
            selectedExhaustedWarningNoReset: '{{account}} no tiene cupo de publicación disponible.',
            unavailable:
                'El uso de publicaciones no está disponible ahora. Aún puedes publicar; los límites del backend se comprobarán al enviar.'
        },
        noEligibleAccountsTitle: 'No hay cuentas de publicación disponibles',
        noEligibleAccountsDescription: 'Conecta una cuenta de Instagram o X antes de crear una entrada.',
        noHandle: 'No hay identificador público disponible',
        selectedBadge: 'Seleccionado',
        notSelectedBadge: 'No seleccionado',
        comingSoon: 'Próximamente',
        additionalMediaItemsTitle: 'Elementos multimedia adicionales',
        additionalMediaItemsDescription: 'Se mantiene para carruseles, publicaciones en X y videos.',
        mediaPublicUrlHint: 'El contenido multimedia se envía como URL pública.',
        noAccountsBadge: 'Sin cuenta',
        mediaStepHint: 'Agrega los detalles multimedia y el texto de esta publicación.',
        textOnlyHint: 'Las publicaciones solo de texto en X envían el texto sin elementos multimedia.',
        instagramNoImageHint: 'Sin una imagen cargada, esta publicación no se publicará en Instagram.',
        mediaItemsTitle: 'Elementos multimedia',
        mediaItemsHint: 'Agrega una o más imágenes o videos cuando esta publicación deba incluir contenido multimedia.',
        multiMediaBadge: '{{count}} elementos multimedia',
        addMediaAction: 'Agregar multimedia a la publicación',
        removeMediaAction: 'Eliminar',
        mediaItemTitle: 'Elemento multimedia {{index}}',
        publicFetchUrlMirrorsSourceHint:
            'El backend requiere sourceUrl. Este campo se reutiliza como sourceUrl y publicFetchUrl cuando enviamos la publicación.',
        altTextPlaceholder: 'Descripción accesible para este elemento multimedia',
        captionPlaceholder: 'Escribe el texto de la publicación…',
        submitAction: 'Publicar entrada',
        scheduleSubmitAction: 'Programar publicación',
        subscriptionInactiveDescription:
            'Renueva la suscripción de esta organización antes de crear un nuevo trabajo de publicación.',
        stepCompleteBadge: 'Hecho',
        submitting: 'Publicando...',
        successToast: 'Trabajo de publicación creado.',
        successToastScheduled: 'Trabajo de publicación programado.',
        livePreviewTitle: 'Vista previa en vivo',
        livePreviewDescription: 'Previsualiza la publicación mientras la compones o ábrela en pantalla completa.',
        fullscreenPreviewAction: 'Pantalla completa',
        selectDateAction: 'Seleccionar fecha',
        previewAccountPlaceholder: 'Cuenta social seleccionada',
        previewHandlePlaceholder: '@cuenta',
        previewMediaPlaceholder: 'Vista previa del contenido',
        previewCaptionPlaceholder: 'Tu texto aparecerá aquí mientras escribes.',
        previewAdditionalMediaCount: '+{{count}} más',
        previewScheduledBadge: 'Programado',
        videoPreviewLabel: 'Vista previa del video',
        twitterPreviewComingSoon:
            'La vista previa de Twitter/X usa la cuenta de X seleccionada y el contenido de la publicación.',
        postPublishingTitle: 'Publicación de la entrada',
        stepFlowTitle: 'Compositor paso a paso',
        stepFlowDescription:
            'Completa cada bloque en orden. Los bloques posteriores permanecen bloqueados hasta que el anterior esté listo.',
        publishModes: {
            now: 'Publicar ahora',
            nowDescription: 'Inicia el flujo de publicación inmediatamente después del envío.',
            scheduled: 'Programar para más tarde',
            scheduledDescription: 'Programa esta publicación para una fecha y hora futuras.'
        },
        platforms: {
            instagram: 'Instagram',
            twitter: 'Twitter / X'
        },
        steps: {
            socialAccounts: 'Cuentas sociales',
            targets: 'Destinos',
            publishingTime: 'Hora de publicación',
            postContent: 'Contenido de la publicación'
        },
        fields: {
            platform: 'Plataforma de destino',
            socialAccount: 'Cuenta social',
            mediaItems: 'Elementos multimedia',
            mediaUrl: 'URL del contenido',
            captionHelp: 'Mantén el texto claro y listo para la plataforma.',
            mediaType: 'Tipo de medio',
            sourceUrl: 'URL de origen',
            publicFetchUrl: 'URL pública de acceso',
            altText: 'Texto alternativo',
            caption: 'Texto',
            requestedPublishAt: 'Programado para',
            scheduleDate: 'Fecha',
            publishTime: 'Hora de publicación',
            publishAtLocalTime: 'Publicar a las (hora local)',
            scheduleTime: 'Hora'
        },
        placeholders: {
            primaryMediaUrl: 'https://cdn.yourapp.com/photo.jpg',
            additionalMediaUrl: 'https://cdn.example.com/post-image.jpg'
        },
        mediaTypes: {
            text: 'Solo texto',
            image: 'Imagen',
            video: 'Video'
        },
        validation: {
            generic: 'Revisa el formulario de publicación y corrige los campos resaltados.',
            socialAccountRequired: 'Selecciona una cuenta social antes de continuar.',
            platformRequired: 'Selecciona una plataforma de destino disponible.',
            mediaItemRequired: 'Agrega al menos un elemento multimedia para las plataformas seleccionadas.',
            mediaTypeInvalid: 'Las publicaciones de solo texto están disponibles solo para X.',
            publishModeRequired: 'Elige una opción de hora de publicación antes de continuar.',
            captionRequired: 'El texto es obligatorio.',
            publicFetchUrlRequired: 'La URL pública de acceso es obligatoria.',
            publicFetchUrlInvalid: 'La URL pública de acceso debe ser una URL válida.',
            xCarouselImagesOnly:
                'Los carruseles de X solo admiten imágenes. Publica un video en X como una publicación de un solo archivo multimedia.',
            xCarouselImageCount: 'Los carruseles de X admiten como máximo {{count}} imágenes.',
            requestedPublishAtRequired: 'Elige una fecha y hora programadas.',
            requestedPublishAtInvalid: 'La fecha y hora programadas deben ser válidas.',
            requestedPublishAtFuture: 'La fecha y hora programadas deben estar en el futuro.'
        }
    },

    insights: {
        pageTitle: 'Estadísticas de Instagram',
        pageDescription: 'Elige una cuenta y un intervalo de fechas. La página se actualiza según esos dos filtros.',
        emptyOrganizationDescription: 'Selecciona o crea una organización para ver las estadísticas de Instagram.',
        accountPickerLabel: 'Cuenta de Instagram',
        accountPickerPlaceholder: 'Selecciona una cuenta',
        noInsightsAccounts:
            'Ninguna cuenta de Instagram conectada admite estadísticas todavía. Conecta primero una cuenta profesional de Instagram.',
        noInsightsAccountsHelp:
            'Conecta una cuenta de Instagram con acceso a estadísticas para desbloquear métricas de resumen, demografía de audiencia y desgloses de contenido.',
        subscriptionInactiveTitle: 'Insights pausados',
        subscriptionInactiveDescription:
            'Las actualizaciones de insights de Instagram están pausadas mientras la suscripción de esta organización esté inactiva.',
        subscriptionInactiveHelp: 'Renueva la suscripción para volver a obtener datos recientes de insights.',
        connectAccountCta: 'Ir a cuentas sociales',
        dateRangeLabel: 'Rango de fechas',
        dateRange: {
            last7Days: 'Últimos 7 días',
            last14Days: 'Últimos 14 días',
            last30Days: 'Últimos 30 días'
        },
        overviewTitle: 'Resumen',
        tabs: {
            overview: 'Resumen',
            content: 'Desglose de contenido',
            trend: 'Tendencia',
            breakdowns: 'Desgloses',
            audience: 'Audiencia',
            advanced: 'Consulta avanzada'
        },
        currentViewLabel: 'Vista actual',
        currentViewTitle: 'Estadísticas de la cuenta de Instagram',
        currentViewDescription:
            'Las tarjetas de resumen muestran las cifras principales. Usa las pestañas de abajo para tendencias, desgloses, audiencia y exploración de consultas sin procesar.',
        trendTitle: 'Alcance a lo largo del tiempo',
        trendTitleWithMetric: '{{metric}} a lo largo del tiempo',
        trendDescription: 'Cuentas únicas alcanzadas por día en el período seleccionado.',
        trendTracking: 'Seguimiento de {{metric}} en el rango seleccionado.',
        chartValueLabel: 'Valor',
        overviewSectionPrimaryLabel: '// principal',
        overviewSectionEngagementLabel: '// interacción',
        quickSegmentTitle: 'Resumen rápido de segmentos',
        quickSegmentDescription: 'Una lectura rápida del desglose de contenido más fuerte para la métrica activa.',
        topSegment: 'Segmento principal',
        topAudience: 'Audiencia principal',
        rankTop: 'Principal',
        primaryMetricBadge: 'Principal',
        metricHelpLabel: 'Ayuda de {{metric}}',
        filtersBadge: 'Estadísticas de Instagram',
        filtersTitle: 'Enfocar el panel',
        filtersDescription: 'Elige una cuenta y un rango de fechas. La página se actualiza con esos dos filtros.',
        filtersAction: 'Filtros',
        filtersSheetTitle: 'Filtros de estadísticas',
        filtersSheetDescription: 'Ajusta la cuenta y el rango de fechas del panel.',
        breakdownTitle: 'Desgloses de métricas',
        breakdownDescription: 'Divide el total de una métrica por una dimensión admitida.',
        breakdownMetricLabel: 'Métrica',
        breakdownDimensionLabel: 'Desglose',
        breakdownColumns: {
            rank: 'Rango',
            dimension: 'Dimensión',
            value: 'Valor',
            share: 'Porcentaje'
        },
        breakdownTotal: 'Total: {{value}}',
        audienceTitle: 'Demografía de la audiencia',
        audienceDescription: 'Quién sigue e interactúa con esta cuenta.',
        audienceMetricLabel: 'Audiencia',
        audienceMetrics: {
            follower_demographics: 'Seguidores',
            engaged_audience_demographics: 'Audiencia que interactúa'
        },
        audienceBreakdownLabel: 'Agrupar por',
        audienceBreakdowns: {
            country: 'País',
            city: 'Ciudad',
            age: 'Edad',
            gender: 'Género'
        },
        audienceTimeframeLabel: 'Período',
        audienceTimeframes: {
            this_week: 'Esta semana',
            this_month: 'Este mes'
        },
        advancedTitle: 'Consulta avanzada',
        advancedDescription:
            'Envía una consulta personalizada a la API de estadísticas de Instagram e inspecciona la respuesta sin procesar.',
        advancedExplorerDescription:
            'El explorador es secundario a propósito. Úsalo para validar métricas de casos límite, desgloses no admitidos y payloads de API sin procesar.',
        advancedBadges: {
            rawApiQueryBuilder: 'Constructor de consultas API sin procesar',
            debugFirst: 'Depuración primero'
        },
        advancedMetricLabel: 'Métricas (separadas por comas)',
        advancedMetricPlaceholder: 'reach',
        advancedPeriodLabel: 'Período',
        advancedMetricTypeLabel: 'Tipo de métrica',
        advancedBreakdownLabel: 'Desglose',
        advancedBreakdownPlaceholder: 'media_product_type',
        advancedTimeframeLabel: 'Marco temporal',
        advancedSinceLabel: 'Desde',
        advancedUntilLabel: 'Hasta',
        advancedRun: 'Ejecutar consulta',
        advancedNone: 'Ninguno',
        advancedPeriods: {
            day: 'Día',
            week: 'Semana',
            days_28: '28 días',
            lifetime: 'Vida completa'
        },
        advancedMetricTypes: {
            total_value: 'Valor total',
            time_series: 'Serie temporal'
        },
        rawResponseTitle: 'Respuesta sin procesar',
        metrics: {
            reach: 'Alcance',
            accounts_engaged: 'Cuentas que interactuaron',
            total_interactions: 'Interacciones totales',
            likes: 'Me gusta',
            comments: 'Comentarios',
            shares: 'Compartidos',
            saves: 'Guardados',
            views: 'Visualizaciones',
            follows_and_unfollows: 'Seguimientos y abandonos',
            profile_links_taps: 'Toques en enlaces del perfil'
        },
        metricDescriptions: {
            reach: 'Cuentas únicas que vieron el contenido de la cuenta en el rango seleccionado.',
            accounts_engaged: 'Cuentas únicas que interactuaron con el contenido de la cuenta.',
            total_interactions: 'Interacciones combinadas en las acciones de engagement admitidas.',
            default: 'Métrica general de estadísticas de la cuenta.'
        },
        breakdownDimensions: {
            REELS: 'Reels',
            POSTS: 'Publicaciones',
            STORIES: 'Historias',
            CAROUSEL_CONTAINER: 'Publicaciones en carrusel',
            FOLLOWER: 'Seguidores',
            NON_FOLLOWER: 'No seguidores',
            FOLLOWERS: 'Seguidores',
            NON_FOLLOWERS: 'No seguidores',
            MEDIA_PRODUCT_TYPE: 'Tipo de producto multimedia',
            FOLLOW_TYPE: 'Tipo de seguimiento',
            CONTACT_BUTTON_TYPE: 'Tipo de botón de contacto',
            THIS_WEEK: 'Esta semana',
            THIS_MONTH: 'Este mes',
            UNKNOWN: 'Desconocido',
            M: 'Masculino',
            F: 'Femenino',
            U: 'Desconocido'
        },
        noData: 'Esta consulta no devolvió datos.',
        retry: 'Reintentar',
        unknownError: 'Error desconocido'
    },
    apiDocs: {
        pageTitle: 'Documentación API',
        pageDescription: 'Inicio rápido, tarjetas de endpoints y documentación API incrustada en un solo lugar.',
        openFullDocumentation: 'Abrir documentación completa',
        subscriptionInactiveDescription:
            'Las claves API de la organización están suspendidas mientras el acceso de la suscripción esté inactivo, por lo que las solicitudes API autenticadas para esta organización fallarán hasta que se renueve la facturación.',
        shell: {
            defaultDocsLocaleLabel: 'Predeterminado',
            fallbackNotice:
                'No existe un artefacto de documentación dedicado para el idioma del frontend {{frontendLanguage}}, así que la página usó {{docsLanguage}} como alternativa.',
            organizationIdLabel: 'ID de organización activa',
            organizationIdDescription:
                'Usa este ID cuando un endpoint de la API requiera el parámetro de ruta de la organización activa.',
            copyOrganizationId: 'Copiar ID de organización',
            organizationIdCopied: 'ID de organización copiado.',
            noActiveOrganizationId: 'No hay una organización activa seleccionada.',
            iframeRegionLabel: 'Contenedor embebido de documentación API',
            iframeTitle: 'Documentación API embebida para {{language}}',
            loadErrorTitle: 'No se pudo cargar el manifiesto de documentación',
            loadErrorDescription: 'No se pudo cargar el manifiesto de documentación: {{error}}',
            loadErrorFallback: 'Error desconocido del manifiesto de documentación.',
            noDocsTitle: 'No se encontraron artefactos de documentación generados',
            noDocsDescription:
                'Se cargó el manifiesto de documentación, pero no había páginas estáticas generadas disponibles para incrustar.'
        }
    },
    socialAccounts: {
        pageTitle: 'Cuentas sociales',
        loadingDescription: 'Cargando cuentas sociales...',
        pageDescription: 'Administra las superficies de cuentas sociales conectadas para tu espacio de trabajo.',
        subscriptionInactiveDescription:
            'Agregar o reconectar cuentas sociales está pausado hasta renovar la suscripción de esta organización.',
        sourceLimit: {
            title: 'Límite de fuentes alcanzado',
            description:
                'Esta organización usa {{used}} de {{limit}} fuentes compradas. Compra más fuentes antes de conectar otra cuenta.',
            actionBlockedToast: 'Límite de fuentes alcanzado. Compra más fuentes antes de conectar otra cuenta social.',
            checking: 'Comprobando el límite de fuentes…',
            unavailable:
                'La conexión de nuevas cuentas está pausada hasta que se pueda comprobar de nuevo el límite de fuentes.',
            unavailableTitle: 'No se pudo verificar el límite de fuentes',
            unavailableRetry: 'Reintentar comprobación',
            manageBillingAction: 'Gestionar facturación',
            ownerHint: 'Pide a un propietario o administrador de la organización que compre más fuentes.'
        },
        searchPlaceholder: 'Buscar cuentas sociales',
        rowsPerPage: 'Filas por página',
        empty: 'No se encontraron cuentas sociales.',
        emptyState: {
            title: 'Todavía no hay cuentas conectadas'
        },
        table: {
            title: 'Cuentas conectadas',
            totalCount: '{{count}} cuentas en total'
        },
        columns: {
            id: 'ID',
            accountName: 'Nombre de la cuenta',
            type: 'Tipo',
            status: 'Estado',
            actions: 'Acciones',
            actionsDescription: 'Abre el menú de acciones de esa cuenta.'
        },
        actions: {
            menuLabel: 'Acciones de la cuenta',
            copyId: 'Copiar ID de la cuenta',
            refresh: 'Reconectar',
            reconnect: 'Reconectar',
            delete: 'Eliminar'
        },
        types: {
            instagram: 'Instagram',
            x: 'X'
        },
        statuses: {
            active: 'Conectada',
            degraded: 'Degradada',
            reauthorization_required: 'Requiere reconexión',
            disconnected: 'Desconectada',
            error: 'Error'
        },
        pagination: {
            previous: 'Anterior',
            next: 'Siguiente',
            page: 'Página {{page}} de {{totalPages}}',
            summary: 'Mostrando {{start}}-{{end}} de {{total}} cuentas',
            summaryCompact_one: '{{count}} cuenta · Página {{page}} de {{totalPages}}',
            summaryCompact_other: '{{count}} cuentas · Página {{page}} de {{totalPages}}'
        },
        connectDialog: {
            trigger: 'Agregar nueva cuenta',
            title: 'Agregar nueva cuenta',
            description: 'Elige una fuente social para conectar.',
            liveBadge: 'Activo',
            comingSoonLabel: '// próximamente',
            trustCopy: 'Autorizas directamente con la plataforma. Nunca vemos tu contraseña.',
            comingSoonPlatforms: {
                tiktok: 'TikTok',
                facebook: 'Facebook',
                linkedin: 'LinkedIn',
                youtube: 'YouTube'
            },
            platforms: {
                instagram: {
                    name: 'Instagram',
                    requirement: 'Cuenta Business o Creator, vinculada a una página de Facebook.'
                },
                x: {
                    name: 'X',
                    requirement: 'Cualquier cuenta de X.'
                }
            },
            connectInstagram: 'Conectar cuenta de Instagram',
            connectX: 'Conectar cuenta de X'
        },
        deleteDialog: {
            title: 'Eliminar cuenta social',
            description: '¿Eliminar "{{accountName}}" de esta organización?',
            success: 'Cuenta social eliminada'
        },
        callback: {
            success: 'Cuenta social conectada correctamente',
            error: 'Falló la conexión de la cuenta social'
        },
        emptyOrganizationTitle: 'No hay una organización seleccionada',
        emptyOrganizationDescription: 'Selecciona una organización antes de administrar cuentas sociales.',
        errors: {
            missingAuthorization: 'No se encontró una autorización administrable para esta cuenta social.'
        },
        idCopied: 'ID de cuenta social copiado'
    },
    organizationMembers: {
        pageTitle: 'Miembros de la organización',
        pageDescription: 'Administra los miembros de {{organizationName}}.',
        fallbackOrganizationName: 'la organización actual',
        empty: 'No se encontraron miembros para esta organización.',
        count: '{{count}} miembros · Página {{page}} de {{totalPages}}',
        permissionHint:
            'Tu rol actual en la organización permite ver esta página, pero las acciones de gestión de miembros están deshabilitadas para tu nivel de permisos.',
        genericMember: 'este miembro',
        roleUpdated: 'Rol del miembro actualizado',
        lastOwnerBlocked: 'Debe permanecer al menos un propietario en la organización.',
        membershipIdCopied: 'ID de membresía copiado',
        memberActions: 'Acciones del miembro',
        changeRoleTo: 'Cambiar rol a {{role}}',
        memberRemoved: 'Miembro eliminado',
        removeAction: 'Eliminar miembro',
        confirmRemoveTitle: 'Eliminar miembro de la organización',
        confirmRemoveDescription:
            '¿Eliminar a {{memberName}} de esta organización? Esta acción no se puede deshacer desde la interfaz.',
        columns: {
            member: 'Miembro',
            role: 'Rol',
            joinedAt: 'Fecha de incorporación',
            actions: 'Acciones',
            actionsDescription: 'Abre la vista previa o de detalles de ese trabajo de publicación.'
        },
        roles: {
            owner: 'Propietario',
            admin: 'Administrador',
            member: 'Miembro',
            viewer: 'Lector'
        },
        errors: {
            forbidden: 'No tienes permiso para realizar esa acción sobre el miembro.',
            notFound: 'No se encontró ese miembro o esa organización.',
            conflict: 'Ese cambio viola las reglas de membresía de la organización.',
            generic: 'La acción sobre el miembro falló.'
        }
    },
    organizationInvitations: {
        pageTitle: 'Invitaciones de la organización',
        pageDescription: 'Administra las invitaciones de {{organizationName}}.',
        fallbackOrganizationName: 'la organización actual',
        empty: 'No se encontraron invitaciones para esta organización.',
        emptyDashedTitle: 'Todavía no hay invitaciones pendientes para esta organización.',
        count: '{{count}} invitaciones · Página {{page}} de {{totalPages}}',
        permissionHint:
            'Tu rol actual en la organización permite ver invitaciones, pero crear o revocar invitaciones está deshabilitado para tu nivel de permisos.',
        inviteAction: 'Invitar compañero',
        dialogTitle: 'Invitar compañero',
        dialogDescription: 'Crea una invitación para la organización y copia el token de un solo uso.',
        fields: {
            email: 'Correo electrónico',
            role: 'Rol'
        },
        sendInvite: 'Enviar invitación',
        inviting: 'Creando invitación...',
        invitationCreated: 'Invitación creada',
        invitationRevoked: 'Invitación revocada',
        revokeAction: 'Revocar invitación',
        tokenTitle: 'Token de invitación',
        tokenDescription:
            'Este token se muestra solo una vez. Cópialo ahora si necesitas compartirlo o inspeccionarlo.',
        copyToken: 'Copiar token',
        tokenCopied: 'Token de invitación copiado',
        confirmRevokeTitle: 'Revocar invitación',
        confirmRevokeDescription: '¿Revocar la invitación para {{email}}?',
        columns: {
            email: 'Correo electrónico',
            role: 'Rol',
            status: 'Estado',
            expiresAt: 'Expira',
            createdAt: 'Creada',
            actions: 'Acciones',
            actionsDescription: 'Acciones para esta invitación, como revocarla.'
        },
        roles: {
            owner: 'Propietario',
            admin: 'Administrador',
            member: 'Miembro',
            viewer: 'Lector'
        },
        statuses: {
            pending: 'Pendiente',
            accepted: 'Aceptada',
            declined: 'Rechazada',
            revoked: 'Revocada',
            expired: 'Expirada'
        },
        errors: {
            forbidden: 'No tienes permiso para realizar esa acción de invitación.',
            notFound: 'No se encontró esa invitación o esa organización.',
            conflict: 'Esa acción de invitación viola las reglas de estado de la invitación.',
            generic: 'La acción de invitación falló.'
        }
    },
    organizationInvitationAcceptance: {
        pageTitle: 'Invitación de organización',
        pageDescription:
            'Revisa los detalles de la invitación, inicia sesión si hace falta y elige si quieres unirte a la organización.',
        preparingAuth: 'Preparando autenticación…',
        resolving: 'Resolviendo invitación...',
        resolvingDescription: 'Comprobando el token de invitación y cargando los detalles de la invitación.',
        invitationDetailsTitle: 'Detalles de la invitación',
        invitationDetailsDescription:
            'Esta invitación solo puede ser aceptada o rechazada por la cuenta invitada que haya iniciado sesión.',
        fields: {
            organization: 'Organización',
            role: 'Rol',
            email: 'Correo invitado',
            status: 'Estado'
        },
        unknownOrganization: 'Organización desconocida',
        loginRequiredTitle: 'Se requiere iniciar sesión',
        loginRequired: 'Debes iniciar sesión antes de poder responder a esta invitación.',
        loginAction: 'Iniciar sesión para responder a la invitación',
        registerAction: 'Crear una cuenta para responder a la invitación',
        acceptAction: 'Aceptar invitación',
        declineAction: 'Rechazar invitación',
        wrongAccountTitle: 'Hay otra cuenta iniciada',
        wrongAccountDescription:
            'Esta invitación es para {{invitedEmail}}, pero has iniciado sesión como {{currentEmail}}. Cierra sesión e inicia sesión de nuevo con la cuenta invitada.',
        accepting: 'Aceptando invitación...',
        acceptingDescription: 'Te estamos uniendo a la organización ahora.',
        declining: 'Rechazando invitación...',
        decliningDescription: 'Estamos rechazando esta invitación.',
        success: 'Invitación aceptada correctamente.',
        declinedSuccess: 'Invitación rechazada.',
        declinedSuccessDescription: 'La invitación fue rechazada. Te llevamos a tu espacio de trabajo...',
        redirecting: 'Redirigiéndote al espacio de trabajo de la organización...',
        errorTitle: 'No se pudo procesar la invitación',
        errors: {
            missingToken: 'Falta el token de invitación en la URL.',
            unauthorized: 'Inicia sesión e intenta de nuevo con la invitación.',
            invalidToken: 'Esta invitación es inválida, ha expirado, fue rechazada, revocada o ya fue usada.',
            generic: 'La acción de invitación falló.'
        }
    },
    organizationApiKeys: {
        pageTitle: 'Claves API de la organización',
        pageDescription: 'Administra las claves API de {{organizationName}}.',
        fallbackOrganizationName: 'la organización actual',
        empty: 'No se encontraron claves API para esta organización.',
        permissionHint:
            'Tu rol actual en la organización permite ver las claves API, pero crear o revocar claves API está deshabilitado para tu nivel de permisos.',
        subscriptionInactiveDescription:
            'Las claves API existentes están suspendidas y no se pueden crear claves nuevas hasta renovar la suscripción de esta organización.',
        createAction: 'Crear clave API',
        dialogTitle: 'Crear clave API',
        dialogDescription: 'Crea una clave API de organización y copia el token ahora: no se volverá a mostrar.',
        fields: {
            name: 'Nombre',
            permissions: 'Permisos'
        },
        permissionsDescription: 'Elige qué permisos podrá usar esta clave API.',
        permissionsPublishIncludesRead:
            'El acceso de publicación también incluye acceso de lectura y se añadirá automáticamente.',
        permissionsInsightsSeparate:
            'Los permisos de publicación ya no incluyen acceso a insights. Las claves existentes con solo permisos de publicación no pueden leer insights: agrega el permiso de lectura de insights al crear una clave que lo necesite.',
        permissions: {
            publishing_read: {
                label: 'Leer datos de publicación',
                description: 'Permite acceso de solo lectura a recursos de publicación y contenido publicado.'
            },
            publishing_publish: {
                label: 'Publicar medios',
                description: 'Permite crear trabajos de publicación y subir o publicar medios.'
            },
            insights_read: {
                label: 'Leer datos de insights',
                description: 'Permite acceso de solo lectura a datos de insights de Instagram.'
            }
        },
        previewAction: 'Vista previa de la clave API',
        previewExistingAction: 'Ver detalles',
        backToEdit: 'Volver a editar',
        previewTitle: 'Vista previa de la clave API',
        previewDescription: 'Revisa los detalles y permisos de la clave API antes de crearla.',
        resultTitle: 'Clave API creada',
        resultDescription:
            'Copia y guarda el token de la clave API de forma segura, luego revisa los detalles y permisos guardados.',
        previewSummaryTitle: 'Vista previa de la clave API',
        previewSummaryDescription: 'Confirma el nombre de la clave y los alcances antes de generar el token.',
        previewPermissionsDescription: 'Estos son los alcances que se adjuntarán a la nueva clave API.',
        previewExistingTitle: 'Detalles de la clave API',
        previewExistingDescription: 'Revisa los metadatos guardados de la clave API y los permisos concedidos.',
        previewExistingLoading: 'Cargando detalles de la clave API...',
        previewExistingEmpty: 'No se devolvieron detalles para esta clave API.',
        previewExistingEndpointUnavailable:
            'El endpoint de vista previa detallada aún no está disponible, así que este modal muestra los metadatos ya cargados desde la lista de claves API.',
        previewExistingPermissionsDescription: 'Estos son los alcances concedidos actualmente a esta clave API.',
        previewExistingScopesLoaded: 'Los permisos se cargaron desde el endpoint de detalles de la clave API.',
        previewExistingNoScopes: 'No se devolvieron alcances para esta clave API.',
        previewExistingTokenAvailable: 'El token de esta clave API está disponible para mostrarse ahora mismo.',
        previewExistingTokenUnavailable:
            'Esta clave API se puede previsualizar, pero el token en bruto no está disponible para mostrarse.',
        previewExistingLimitation: 'El valor del token no está disponible para esta clave API.',
        previewFields: {
            maskedKey: 'Clave enmascarada',
            fullKey: 'Clave API completa',
            revokedAt: 'Revocada el'
        },
        createSubmit: 'Crear clave',
        creating: 'Creando clave...',
        apiKeyCreated: 'Clave API creada',
        apiKeyRevoked: 'Clave API revocada',
        revokeAction: 'Revocar clave API',
        tokenTitle: 'Token de clave API',
        tokenDescription:
            'Copia y guarda este token de forma segura. Puede seguir disponible en los detalles de la clave API mientras el backend lo permita.',
        copyToken: 'Copiar token',
        tokenCopied: 'Token de clave API copiado',
        confirmRevokeTitle: 'Revocar clave API',
        confirmRevokeDescription: '¿Revocar la clave API "{{apiKeyName}}"?',
        columns: {
            name: 'Nombre',
            status: 'Estado',
            createdAt: 'Creada',
            actions: 'Acciones',
            actionsDescription: 'Abre la vista previa o de detalles de ese trabajo de publicación.'
        },
        statuses: {
            active: 'Activa',
            revoked: 'Revocada',
            suspended: 'Suspendida'
        },
        errors: {
            forbidden: 'No tienes permiso para realizar esa acción de clave API.',
            notFound: 'No se encontró esa clave API o esa organización.',
            conflict: 'Esa acción de clave API viola las reglas de estado de la clave API.',
            generic: 'La acción de clave API falló.'
        }
    },
    organizations: {
        loading: {
            title: 'Cargando organizaciones',
            description: 'Obteniendo tus organizaciones y eligiendo el contexto activo.'
        },
        error: {
            title: 'No se pudieron cargar las organizaciones',
            description: 'No se pudo inicializar el contenedor con soporte para organizaciones.',
            fallback: 'Error desconocido de organizaciones'
        },
        subscriptionInactive: {
            title: 'Suscripción inactiva',
            actionBlockedToast: 'Renueva la suscripción de esta organización antes de usar esta acción.',
            manageBillingAction: 'Gestionar facturación',
            ownerHint: 'Pide a un propietario de la organización que renueve o reactive la facturación.'
        },
        limitBanner: {
            cancelEndingTitle: 'La suscripción termina pronto',
            cancelEndingDescription:
                'Este espacio de trabajo perderá acceso al final del período de facturación actual. Renueva o actualiza la facturación para evitar una interrupción.',
            subscriptionInactiveDescription:
                'Este espacio de trabajo tiene el acceso de facturación inactivo. Actualiza la suscripción para restaurar el acceso completo.',
            trialEndingTitle: 'La prueba termina pronto',
            trialEndingDescription:
                'Tu prueba está por terminar. Agrega los datos de facturación o mejora el plan ahora para evitar una interrupción.',
            manageBillingAction: 'Gestionar facturación',
            socialAccountsReachedTitle: 'Se alcanzó el límite de cuentas sociales',
            socialAccountsReachedDescription:
                'Estás usando {{used}} de {{limit}} espacios de cuentas sociales conectadas. Mejora el plan para conectar más cuentas.',
            upgradeAction: 'Mejorar plan',
            socialAccountsWarningTitle: 'Te acercas al límite de cuentas sociales',
            socialAccountsWarningDescription:
                'Estás usando {{used}} de {{limit}} espacios de cuentas sociales conectadas. Mejora el plan antes de que se bloqueen nuevas conexiones.',
            connectedAccountFallback: 'esta cuenta conectada',
            publishingReachedTitle: 'Se alcanzó la cuota de publicaciones',
            publishingReachedDescription:
                '{{accountName}} ya usó las {{limit}} publicaciones del período de facturación actual. Mejora el plan para seguir publicando.',
            publishingWarningTitle: 'Te acercas a la cuota de publicaciones',
            publishingWarningDescription:
                '{{accountName}} ha usado {{currentUsage}} de {{limit}} publicaciones del período de facturación actual. Mejora el plan antes de que se bloquee la publicación.'
        },
        fields: {
            name: 'Nombre de la organización',
            slug: 'Slug',
            slugHelp:
                'Opcional. Déjalo en blanco para generar automáticamente un slug a partir del nombre de la organización.'
        },
        create: {
            cta: 'Crear organización',
            title: 'Crear organización',
            description: 'Crea una nueva organización y cambia a ella inmediatamente.',
            pageTitle: 'Nueva organización',
            pageDescription: 'Crea una nueva organización y empieza a administrarla de inmediato.',
            pageIntro: 'Configura una nueva organización',
            pageHint:
                'Después de crearla, la nueva organización se convierte automáticamente en el contexto activo y serás redirigido de vuelta a la app.',
            sectionTitle: 'Crear otra organización',
            sectionDescription:
                'Crea una nueva organización directamente desde la página Organizations y actívala de inmediato.',
            hideSection: 'Ocultar formulario',
            submit: 'Crear',
            submitting: 'Creando...',
            success: 'Organización creada',
            error: 'No se pudo crear la organización',
            conflictError: 'Ya existe una organización con ese nombre o slug.',
            validationFallback: 'Corrige los errores del formulario e inténtalo de nuevo.'
        },
        switcher: {
            label: 'Organizaciones',
            selectOrganization: 'Seleccionar organización',
            loadMore: 'Cargar más organizaciones ({{shown}}/{{total}})',
            loadError: 'No se pudieron cargar las organizaciones.',
            emptyTitle: 'Todavía no hay organizaciones',
            emptyDescription: 'Crea tu primera organización para desbloquear las páginas con alcance de organización.'
        },
        emptyState: {
            title: 'Crea tu primera organización',
            description:
                'Todavía no tienes una organización. Crea una para inicializar el contexto del espacio de trabajo y desbloquear páginas con alcance de organización.'
        },
        onboarding: {
            title: 'Organizaciones',
            description:
                'Crea aquí tu primera organización. Una vez que tengas una, el resto de la app estará disponible normalmente.',
            createTitle: 'Crea tu primera organización',
            createDescription:
                'Empieza aquí para establecer el contexto de organización del que depende el resto del producto.',
            workspaceSetupTitle: 'Completar configuración de la organización',
            workspaceSetupDescription:
                'Las cuentas sin organizaciones todavía pueden usar Organizations y Settings para que puedas terminar la configuración y administrar tu perfil.',
            nextStepsTitle: 'Qué pasa después',
            nextStepsDescription:
                'Una vez exista la primera organización, la app puede continuar con el flujo normal del espacio de trabajo.',
            nextStepsCreate:
                'Crea la organización que se convertirá en tu contexto predeterminado del espacio de trabajo.',
            nextStepsInvite:
                'Después de crearla, puedes volver aquí para invitar compañeros y ampliar la organización.',
            nextStepsUnlock:
                'Las páginas con alcance de organización estarán disponibles automáticamente después de crear la primera organización.'
        },
        pageShell: {
            title: 'Organizaciones',
            description: 'Un lugar dedicado al contexto de organización, su creación y futuras superficies de gestión.',
            overview: {
                title: 'Espacio de trabajo de la organización',
                description: 'Revisa tus organizaciones actuales y elige el contexto activo para el resto de la app.',
                currentState: 'Organización activa'
            },
            metrics: {
                totalOrganizations: 'Total de organizaciones',
                activeOrganization: 'Organización activa',
                activeRole: 'Rol activo',
                noneSelected: 'No seleccionado'
            },
            list: {
                count: '{{count}} resultados',
                title: 'Tus organizaciones',
                description:
                    'Consulta todas las organizaciones a las que perteneces y cambia desde aquí el contexto activo.',
                switchAction: 'Hacer activa',
                membershipIdLabel: 'ID de membresía: {{membershipId}}'
            },
            quickActions: {
                title: 'Acciones rápidas',
                description: 'Inicia flujos de organización desde un solo lugar.',
                hint: 'Esta página se convertirá en el destino principal para el onboarding y la gestión de organizaciones.'
            },
            tabs: {
                title: 'Secciones de organización',
                description: 'Cambia entre las áreas de gestión de la organización activa.',
                organizations: 'Organizaciones',
                members: 'Miembros',
                invitations: 'Invitaciones',
                membersDescription: 'Administra los miembros de la organización activa.',
                invitationsDescription: 'Administra las invitaciones de la organización activa.'
            },
            membersPlaceholder: {
                title: 'Marcador de posición para la sección de miembros',
                description:
                    'La gestión de miembros vivirá aquí una vez que la página dedicada de Organizations absorba el flujo actual de miembros.'
            },
            invitationsPlaceholder: {
                title: 'Marcador de posición para la sección de invitaciones',
                description:
                    'La gestión de invitaciones vivirá aquí una vez que la página Organizations absorba el flujo actual de invitaciones.'
            },
            routingNotice: 'Members e Invitations ahora viven bajo Organizations. API Keys sigue separado por ahora.'
        }
    },
    confirmDialog: {
        loading: 'Cargando...'
    },
    oauthConsent: {
        pageTitle: 'Autorizar acceso',
        pageDescription: 'Revisa esta solicitud antes de conceder acceso a los datos de tu espacio de trabajo.',
        clientRequestTitle: '{{clientName}} está solicitando acceso',
        clientRequestDescription:
            'Al aprobar, permites que esta aplicación actúe en tu nombre con los permisos indicados abajo.',
        scopesTitle: 'Permisos solicitados',
        scopesEmpty: 'No se solicitaron permisos específicos.',
        scopes: {
            mcp: 'Acceso completo a MCP',
            mcpDescription: 'Herramientas de publicación y estadísticas a través de la puerta de enlace MCP.'
        },
        expiresAt: 'Esta solicitud expira el {{date}}.',
        organizationTitle: 'Organización',
        organizationDescription: 'Elige a qué organización puede acceder esta aplicación.',
        organizationSingleDescription: 'El acceso se concederá para esta organización.',
        organizationsEmptyTitle: 'No hay ninguna organización disponible',
        organizationsEmptyDescription: 'Necesitas al menos una organización antes de poder aprobar esta solicitud.',
        approve: 'Aprobar',
        deny: 'Denegar',
        approving: 'Aprobando...',
        denying: 'Denegando...',
        redirecting: 'Redirigiendo…',
        redirectsTo: 'Serás redirigido a {{url}}.',
        continueToClient: 'Continuar a {{host}}',
        redirectBlocked: 'El destino de redirección no está permitido, por lo que no fuiste redirigido.',
        errorTitle: 'Esta solicitud no se puede completar',
        errors: {
            missingRequest: 'Falta la referencia de la solicitud de consentimiento en la URL.'
        }
    },

    onboardingFlow: {
        placeholderPreviewTitle: 'Vista previa',
        placeholderPreviewDescription: 'El contenido de vista previa específico del paso se mostrará aquí.',
        stepPlaceholderDescription:
            'La implementación llegará en los PRs de pasos posteriores. Este PR de shell solo conecta rutas, layout, estado compartido y navegación.',
        stepBadge: 'Paso {{step}}',
        saveFailed: 'No se pudo guardar tu progreso de onboarding. Inténtalo de nuevo.',
        back: 'Atrás',
        continue: 'Continuar',
        next: 'Siguiente',
        pricePerMonth: '${{price}}/mes',
        finish: 'Finalizar',
        steps: {
            personalize: 'Personalizar',
            connect: 'Conectar',
            activate: 'Activar',
            personalizeLabel: '01 · Personalizar',
            connectLabel: '02 · Conectar'
        },
        shell: {
            breadcrumb: 'Configuración inicial',
            help: 'Abrir ayuda del onboarding',
            counter: 'onboarding · {{current}} / {{total}}'
        },
        personalize: {
            title: 'Personalizar',
            description:
                'Cuéntanos qué estás construyendo para adaptar tu onboarding y los valores predeterminados de la organización.',
            badge: 'Paso 01 · Personalizar',
            heroTitle: '¿Qué estás construyendo?',
            goalsTitle: '¿Qué quieres hacer primero?',
            goalsLabel: '// elige tus objetivos',
            buildModeTitle: '¿Cómo quieres construirlo?',
            buildModeLabel: '// cómo lo vas a construir',
            sourcesTitle: '¿Cuántas fuentes esperas conectar?',
            sourcesLabel: '// fuentes conectadas',
            sourcesDescription: 'Se incluyen 2 fuentes. Las fuentes adicionales cuestan $5/mes cada una.',
            sourcesHelper: '2 incluidas, luego $5/mes cada una.',
            templatesIncluded: '17 plantillas iniciales incluidas en todos los planes',
            decreaseSources: 'Reducir número de fuentes',
            increaseSources: 'Aumentar número de fuentes',
            goalSingular: 'objetivo',
            goalPlural: 'objetivos',
            summary: '{{goalCount}} {{goalLabel}} · {{mode}} · {{sources}} fuentes · {{price}}/mes',
            previewEmpty: 'Elige uno o más objetivos para ver el resumen de configuración.',
            previewGoals: 'Objetivos seleccionados',
            previewBuildMode: 'Modo de construcción',
            previewSources: 'Fuentes declaradas: {{count}}',
            previewPrice: 'Precio estimado: {{price}}',
            goals: {
                publish: {
                    label: 'Publicar contenido',
                    description: 'Enviar contenido a canales con el mínimo código auxiliar.',
                    cardTitle: 'Publicar y programar',
                    cardDescription: 'Reels, carruseles e historias — según tu calendario',
                    endpointChip: 'POST /v1/publish/post',
                    recipeTitle: 'Programador de contenido',
                    recipeDescription:
                        'Pon en cola y publica automáticamente reels y carruseles desde tu propia app o base de datos.'
                },
                comments: {
                    label: 'Moderar comentarios',
                    description: 'Automatizar respuestas, triaje y flujos de moderación.',
                    cardTitle: 'Comentarios y menciones',
                    cardDescription: 'Trae conversaciones en el momento en que ocurren',
                    endpointChip: 'GET /v1/read/comments',
                    recipeTitle: 'Listener de menciones',
                    recipeDescription: 'Un webhook se activa cuando alguien te menciona — envíalo a Slack o a tu CRM.'
                },
                analytics: {
                    label: 'Leer analíticas',
                    description: 'Llevar métricas de cuenta y contenido a tu app.',
                    cardTitle: 'Analíticas e insights',
                    cardDescription: 'Alcance, crecimiento y mejor hora para publicar',
                    endpointChip: 'GET /v1/read/analytics',
                    recipeTitle: 'Dashboard de analíticas',
                    recipeDescription:
                        'Métricas de alcance, crecimiento y mejor hora, calculadas para ti y enviadas a tu base de datos.'
                },
                ai: {
                    label: 'Lanzar agentes de IA',
                    description: 'Combinar herramientas de contenido con flujos guiados por agentes.',
                    cardTitle: 'Respuestas de comentarios con IA',
                    cardDescription: 'Redacta respuestas con tu tono — aprueba o envía automáticamente',
                    endpointChip: 'MCP · herramientas de respuesta',
                    recipeTitle: 'Asistente de respuestas a comentarios',
                    recipeDescription:
                        'Un agente de IA redacta respuestas con el tono de tu marca; tú las apruebas o las envías automáticamente.'
                },
                ugc: {
                    label: 'Gestionar UGC',
                    description: 'Recoger y enrutar contenido de creadores con aprobaciones.',
                    cardTitle: 'Republicar UGC',
                    cardDescription: 'Encuentra contenido etiquetado y repúblícalo',
                    endpointChip: 'GET /v1/read/mentions',
                    recipeTitle: 'Herramienta de republicación UGC',
                    recipeDescription:
                        'Encuentra publicaciones etiquetadas, solicita derechos y republica — todo el ciclo automatizado.'
                },
                webhooks: {
                    label: 'Escuchar webhooks',
                    description: 'Reaccionar a eventos de cuenta y publicación.',
                    cardTitle: 'Webhooks y eventos',
                    cardDescription: 'Webhooks firmados para comentarios, menciones y DMs',
                    endpointChip: 'POST /v1/webhooks',
                    recipeTitle: 'Relay de eventos',
                    recipeDescription: 'Webhooks firmados y reintentados para cada comentario, mención y DM.'
                }
            },
            buildModes: {
                code: {
                    label: 'Escribiendo código',
                    description: 'Quiero control total de la API e implementación directa.',
                    summary: 'API REST y SDKs'
                },
                agent: {
                    label: 'Con un agente de IA',
                    description: 'Quiero que un agente ayude a conectar y automatizar la configuración.',
                    summary: 'MCP para Claude y Cursor'
                },
                both: {
                    label: 'Ambos',
                    description: 'Control orientado a código con ayuda de agentes cuando convenga.',
                    summary: 'Código + agentes'
                }
            }
        },
        connect: {
            title: 'Conectar Instagram',
            description:
                'Conecta ahora al menos una cuenta profesional de Instagram, o sáltalo y ve directo al checkout de prueba.',
            badge: 'Paso 02 · Conectar',
            headingTitle: 'Conectar',
            headingEmphasis: 'Conecta Instagram.',
            headingRest: 'Una cuenta profesional ahora, o salta al checkout.',
            requirementsLabel: '// requisitos',
            afterTrial: '/mes después de la prueba',
            trialBadge: 'Prueba de 7 días',
            completedBadge: 'Checkout completado',
            connectLaterBadge: 'Conectar más tarde',
            priceStripBreakdown: '{{sources}} fuentes · 2 incluidas en la base de $9',
            priceStripTerms: 'Prueba de 7 días · tarjeta el día 0 · primer cobro el día 8',
            skip: 'Omitir por ahora — ir directo al checkout de prueba',
            trust: {
                secureTitle: 'Solo OAuth seguro',
                secureDescription:
                    'Nunca te pedimos la contraseña de Instagram. Autorizas el acceso directamente con Meta.',
                setupTitle: 'Listo para publicar',
                setupDescription:
                    'Usamos esta conexión para preparar programación, publicación y analíticas para tu organización.',
                laterTitle: 'Puedes añadir más después',
                laterDescription: 'Conecta una cuenta ahora y añade más cuando tu equipo esté listo.'
            },
            requirementsTitle: 'Requisitos antes de conectar',
            requirements: {
                professional: 'Tu cuenta de Instagram debe ser profesional, de tipo Business o Creator.',
                page: 'Esa cuenta de Instagram ya debe estar vinculada a una página de Facebook.'
            },
            connectionTitle: 'Conexión de Instagram',
            connectionDescription:
                'Autoriza Instagram a través de Meta: te redirigiremos y volverás directamente aquí.',
            connectedCounter: 'conectadas: {{connected}} / {{sources}}',
            declaredSources: 'Fuentes declaradas: {{count}}',
            connected: 'Conectadas: {{count}}',
            syncedSources: 'Fuentes sincronizadas: {{count}}',
            errorTitle: 'La conexión falló',
            errors: {
                callbackFailed: 'No se pudo conectar tu cuenta de Instagram. Inténtalo de nuevo.',
                popupBlocked:
                    'El popup de inicio de sesión de Instagram fue bloqueado. Habilita los popups e inténtalo de nuevo.',
                oauthDenied: 'La autorización de Instagram se canceló antes de conceder los permisos.',
                personalAccount:
                    'Solo se admiten cuentas profesionales de Instagram. Cambia esta cuenta a Business o Creator primero.',
                missingPage:
                    'Esta cuenta de Instagram debe estar conectada a una página de Facebook antes de poder usarse aquí.'
            },
            ctaConnect: 'Conectar cuenta de Instagram',
            ctaConnectAnother: 'Conectar otra cuenta',
            ctaConnectShort: 'Conectar cuenta',
            ctaConnected: 'Conectada',
            ctaWaiting: 'Esperando a Instagram…',
            previewTitle: 'Cuentas conectadas',
            previewDescription:
                'La cantidad de cuentas conectadas puede aumentar automáticamente la cantidad de fuentes.',
            previewSourcesNow: 'Fuentes ahora: {{count}}',
            previewEmptyTitle: 'Todavía no hay cuentas de Instagram conectadas',
            previewEmptyDescription: 'Conecta una cuenta a la izquierda para ver cómo se completa tu onboarding.',
            previewNextStep: 'Siguiente paso',
            previewActivate: 'Activar prueba gratuita',
            previewRequirementsLink: 'Revisar requisitos de Instagram',
            previewSyncedMessage:
                'El estado compartido sincroniza las fuentes hacia arriba. Fuentes declaradas actuales: {{count}}',
            checkoutCanceled: 'El checkout se canceló. Tu estado del onboarding sigue aquí.',
            checkoutUnavailable:
                'El checkout aún no está disponible: no hay ningún producto de facturación configurado. Inténtalo más tarde.',
            finalizingTitle: 'Finalizando tu suscripción',
            finalizingDescription: 'Esperando a que Stripe confirme tu checkout. Esto suele tardar unos segundos.',
            checkoutTitle: 'Precio de la prueba',
            checkoutDescription: 'Ya no hay un Paso 3 separado: el checkout empieza directamente desde aquí.',
            checkoutCta: 'Iniciar prueba de {{days}} días',
            nextToDashboard: 'Ir al estado de bienvenida del dashboard',
            previewConnectLater: 'Conéctalo más tarde desde el dashboard si hace falta.',
            previewTrialDetailsTitle: 'Detalles de la prueba',
            previewTrialDetails:
                'Día 0: se recoge la tarjeta. Día 8: primer cobro. El éxito redirige al estado de bienvenida del dashboard.'
        },
        activate: {
            title: 'Activar tu organización',
            description:
                'Inicia tu prueba gratuita, confirma la cantidad de fuentes y entrega la configuración al estado de bienvenida del dashboard.',
            trialActivatedTitle: 'Prueba activada',
            trialActivatedDescription:
                'Tu organización está lista. El estado de bienvenida del dashboard debería recoger tus objetivos, estado de conexión y plan de {{count}} fuentes.',
            waitingCards: {
                connectionTitle: 'Conexión de Instagram',
                connectionDescription:
                    'Si omitiste la conexión, puedes terminarla desde la checklist de bienvenida del dashboard.',
                workspaceTitle: 'Últimos ajustes de la organización',
                workspaceDescription:
                    'Tus fuentes, objetivos y resumen de activación pasan al estado de bienvenida posterior al checkout.'
            },
            nextToDashboard: 'Ir al estado de bienvenida del dashboard',
            startTrial: 'Iniciar prueba de {{days}} días',
            cancelBannerTitle: 'Checkout cancelado',
            cancelBannerDescription: 'Tu prueba no se inició. Todo lo que configuraste aquí sigue guardado.',
            badge: 'Paso 3 · Activar',
            heroTitle: 'Activa tu prueba gratuita de {{days}} días',
            heroDescription:
                'Todavía no hay cobro real. Este es un handoff simulado de Stripe que conserva tu estado de onboarding durante redirección, cancelación y éxito.',
            postTrialPrice: 'Precio después de la prueba',
            chargedStarting: 'Se cobra a partir del día {{day}}',
            trust: {
                startToday: 'Empieza hoy tu prueba gratuita de {{days}} días',
                cardRequired: 'Se requiere tarjeta para activar tu organización',
                noCharge: 'No se te cobrará hasta el día {{day}}'
            },
            priceBreakdownTitle: 'Desglose de precio',
            priceBreakdownDescription:
                'Ajusta las fuentes antes de iniciar la prueba. El precio sigue usando el helper compartido.',
            sourcesTitle: 'Fuentes',
            sourcesDescription: 'Usa al menos {{count}} fuentes para esta configuración.',
            baseLabel: 'Base ({{count}} fuentes)',
            baseDetail: 'Incluido antes de extras',
            additionalLabel: 'Fuentes adicionales',
            additionalDetailNone: 'No hay fuentes extra seleccionadas',
            additionalDetailSome: '{{count}} × ${{price}}',
            monthlyAfterTrialLabel: 'Mensual después de la prueba',
            monthlyAfterTrialDetail: 'Precio exacto cobrado después de la prueba',
            breakdownIncluded: '{{count}} fuentes incluidas en la base de ${{price}}',
            breakdownExpanded: 'Base de ${{base}} + {{extraCount}} × ${{extraPrice}}',
            stripeHandoffTitle: 'Handoff simulado de Stripe',
            stripeHandoffDescription:
                'Usa los estados simulados para previsualizar redirección, cancelación y éxito sin tocar facturación real.',
            stripeReady: 'Listo para iniciar',
            stripeRedirecting: 'Redirigiendo a Stripe…',
            redirectTitle: 'Redirigiendo a Stripe Checkout',
            redirectDescription:
                'En producción, Stripe recogería aquí la tarjeta y volvería a la app. Por ahora, elige el resultado simulado.',
            simulateCancel: 'Simular vuelta por cancelación',
            simulateSuccess: 'Simular checkout exitoso',
            stripeCtaNote:
                'La CTA inicia una sesión simulada de Stripe y conserva tu estado de onboarding durante el regreso.',
            recapTitle: 'Resumen de configuración',
            recapHeading: 'Listo para activar',
            recapGoals: 'Objetivos seleccionados',
            recapInstagram: 'Instagram',
            recapSources: 'Fuentes',
            recapTrialDetails: 'Detalles de la prueba',
            recapAfterCheckout: 'Después del checkout',
            recapNoneYet: 'Aún ninguno',
            recapConnected: '{{count}} conectadas',
            recapSkipped: 'Todavía no — omitido por ahora',
            recapNotConnected: 'Todavía no conectado',
            recapSourcesValue: '{{count}} fuentes · {{price}} después de la prueba',
            recapTrialValue: '{{days}} días gratis · tarjeta requerida · sin cobro hasta el día {{day}}',
            recapAfterCheckoutPending:
                'El estado de bienvenida del dashboard recibe este resumen cuando el checkout termina con éxito.',
            recapAfterCheckoutComplete: 'Enviar al usuario al estado de bienvenida del dashboard con este resumen.',
            expectedPriceTitle: 'Precio mensual esperado después de la prueba'
        }
    },
    pricing: {
        pageTitle: 'Precios',
        pageDescription: 'Precios claros por fuente que encajan con el resto de la experiencia de la app.',
        eyebrow: 'Precios',
        calculatorTitle: 'Calcula tu precio',
        calculatorDescription: 'Elige cuántas fuentes necesitas y el total mensual se actualizará al instante.',
        accountsLabel: 'Fuentes',
        accountsIncludedLabel: 'Fuentes incluidas en tu plan',
        minAccounts: '{{count}} fuente',
        maxAccounts: '{{count}} fuentes',
        firstTierLabel: 'Primeras {{count}} fuentes',
        firstTierRate: '{{price}} por {{count}} fuentes',
        additionalAccountsLabel: 'Fuentes adicionales',
        additionalAccountsRate: '{{price}} por cada fuente adicional',
        monthlyTotalLabel: 'Total mensual',
        monthlyOnlyHint: 'Estimación en tiempo real, facturada mensualmente',
        customSolutionTitle: '¿Necesitas una solución personalizada?',
        customSolutionDescription: 'Habla con nosotros si necesitas precios para mayor volumen o ayuda de onboarding.',
        trialTitle: 'Prueba de 7 días',
        trialDescription:
            'Empieza con una prueba de 7 días y luego continúa con el mismo plan mensual basado en cantidad.',
        checkoutCta: 'Iniciar prueba en Stripe',
        requiresOrganization: 'Crea o selecciona una organización antes de iniciar el checkout.',
        checkoutForOrganization: 'El checkout se iniciará para {{organizationName}} con la cantidad seleccionada.',
        manageSubscriptionCta: 'Gestionar suscripción',
        alreadySubscribed:
            '{{organizationName}} ya tiene una suscripción activa. Cambia el número de fuentes desde Configuración.',
        contactCta: 'Contáctanos',
        planTitle: 'Tu plan',
        planDescription:
            'Precios mensuales transparentes con {{count}} fuentes incluidas y luego una tarifa fija por cada fuente adicional.',
        month: 'mes',
        accountsSelected: '{{count}} fuentes seleccionadas',
        planFirstTierLine: 'Primeras {{count}} fuentes incluidas',
        planTierCalculation: '{{price}} × {{count}}',
        includedLabel: 'Incluido',
        primaryCta: 'Empezar',
        monthlyOnlyDisclaimer: 'Solo precios mensuales. Sin créditos ni suposiciones sobre facturación anual.',
        features: {
            organizations: 'Organizaciones, miembros e invitaciones',
            socialAccounts: 'Cuentas sociales conectadas',
            publishing: 'Flujos de publicación de contenido',
            insights: 'Estadísticas de Instagram',
            apiKeys: 'Claves API de la organización',
            customerSupport: 'Atención al cliente'
        }
    },
    apiErrors: {
        auth: {
            required: 'Se requiere autenticación.',
            invalidOrExpiredToken: 'Se requiere autenticación. Tu sesión puede ser inválida o haber expirado.'
        },
        validation: {
            invalidRequestBody: 'La solicitud es inválida. Revisa los datos enviados e inténtalo de nuevo.',
            required: 'Este campo es obligatorio.',
            emailInvalid: 'Introduce una dirección de correo válida.',
            stringMaxLength: 'Este valor es demasiado largo.'
        },
        organizations: {
            invalidRequest: 'La solicitud de organización es inválida.',
            conflict: 'Ya existe una organización con esos datos.',
            notFound: 'No se encontró la organización.',
            loadFailed: 'No se pudieron cargar las organizaciones.',
            createFailed: 'No se pudo crear la organización.',
            validation: {
                nameMaxLength: 'El nombre de la organización es demasiado largo.',
                slugMaxLength: 'El slug de la organización es demasiado largo.',
                slugFormat: 'El slug de la organización solo puede contener letras minúsculas, números y guiones.'
            }
        },
        onboarding: {
            updateForbidden:
                'Solo los propietarios y administradores de la organización pueden actualizar el onboarding.',
            validation: {
                goalsRequiredBeforeConnect: 'Selecciona al menos un objetivo de onboarding antes de continuar.'
            }
        },
        billing: {
            invalidRequest: 'La solicitud de facturación es inválida.',
            manageForbidden: 'No tienes permiso para administrar la facturación de esta organización.',
            organizationNotFound: 'No se encontró la organización.',
            organizationOrProductNotFound: 'No se encontró la organización o el producto de facturación.',
            incompleteConfiguration:
                'La facturación todavía no está configurada por completo para este flujo de checkout.',
            lifetimeSubscriptionActive:
                'Esta organización tiene un plan lifetime, por lo que la facturación con Stripe no está disponible. Contacta con invisibleapi para cambiar el plan.',
            integration: 'El proveedor de facturación devolvió un error de integración.',
            productsLoadFailed: 'No se pudieron cargar los planes de facturación.',
            stateLoadFailed: 'No se pudo cargar el estado de facturación de la organización.',
            checkoutFailed: 'No se pudo crear la sesión de checkout.',
            customerPortalFailed: 'No se pudo abrir el portal del cliente.',
            validation: {
                successUrlInvalid: 'La URL de éxito de facturación es inválida.',
                cancelUrlInvalid: 'La URL de cancelación de facturación es inválida.',
                returnUrlInvalid: 'La URL de retorno de facturación es inválida.'
            }
        },
        userProfile: {
            loadFailed: 'No se pudieron cargar los detalles de cuenta.',
            updateFailed: 'No se pudieron guardar los detalles de cuenta.',
            actionEmailFailed: 'No se pudo solicitar el correo de seguridad de la cuenta.',
            accountServiceUnavailable: 'El servicio de cuentas no pudo completar la solicitud en este momento.',
            notFound: 'No se encontró el perfil de cuenta.',
            updateRejected: 'El servicio de cuentas rechazó la actualización de los detalles de cuenta.',
            actionRejected: 'El servicio de cuentas rechazó la solicitud del correo de seguridad.',
            validation: {
                readOnly: 'Este campo es de solo lectura.',
                unsupported: 'Este campo no es compatible.'
            }
        },
        organizationInvitations: {
            listForbidden: 'No tienes permiso para ver invitaciones de esta organización.',
            createForbidden: 'No tienes permiso para invitar miembros a esta organización.',
            revokeForbidden: 'No tienes permiso para revocar invitaciones de esta organización.',
            createConflict:
                'No se puede crear esta invitación porque viola las reglas de invitaciones de la organización.',
            revokeConflict: 'No se puede revocar esta invitación debido a su estado actual.',
            notFound: 'No se encontró la organización o la invitación.',
            invalidToken: 'Esta invitación es inválida, ha expirado, fue revocada o ya fue utilizada.',
            actionFailed: 'No se pudo completar la acción de invitación.'
        },
        organizationMembers: {
            listForbidden: 'No tienes permiso para ver los miembros de esta organización.',
            removeForbidden: 'No tienes permiso para eliminar a este miembro.',
            removeConflict:
                'No se puede eliminar a este miembro porque viola las reglas de membresía de la organización.',
            updateForbidden: 'No tienes permiso para actualizar a este miembro.',
            updateConflict: 'Ese cambio de rol viola las reglas de membresía de la organización.',
            actionFailed: 'No se pudo completar la acción del miembro.',
            validation: {
                roleInvalid: 'El rol de organización seleccionado es inválido.'
            }
        },
        organizationApiKeys: {
            listForbidden: 'No tienes permiso para ver las claves API de esta organización.',
            manageForbidden: 'No tienes permiso para administrar las claves API de esta organización.',
            notFound: 'No se encontró la organización o la clave API.',
            createConflict:
                'No se puede crear esta clave API porque viola las reglas de claves API de la organización.',
            revokeConflict: 'No se puede revocar esta clave API debido a su estado actual.',
            actionFailed: 'No se pudo completar la acción de la clave API.',
            validation: {
                nameMaxLength: 'El nombre de la clave API es demasiado largo.'
            }
        },
        socialAccounts: {
            listFailed: 'No se pudieron cargar las cuentas sociales.',
            connectFailed: 'No se pudo iniciar la conexión de la cuenta social.',
            reconnectFailed: 'No se pudo iniciar el flujo de reconexión de la cuenta social.',
            disconnectFailed: 'No se pudo desconectar la cuenta social.',
            forbidden: 'No tienes permiso para administrar las cuentas sociales de esta organización.',
            notFound: 'No se encontró la organización o la cuenta social.',
            conflict: 'No se pudo completar esta acción de cuenta social debido a su estado actual.'
        },
        publishing: {
            listFailed: 'No se pudieron cargar los trabajos de publicación.',
            detailFailed: 'No se pudieron cargar los detalles del trabajo de publicación.',
            createFailed: 'No se pudo crear el trabajo de publicación.',
            paidPlanLimitExceeded: 'Se alcanzó un límite de publicación del plan de pago.',
            paidPlanLimitExceededForAccount: 'Se alcanzó el límite de publicación para {{account}}.',
            paidPlanLimitExceededUnknownAccount: 'la cuenta seleccionada',
            paidPlanLimitExceededUsageDetails:
                'Uso actual: {{currentUsage}}/{{limit}}. Reservas activas: {{activeReservations}}. Publicaciones solicitadas: {{requestedCount}}.',
            paidPlanLimitExceededResetDetails: 'Inténtalo de nuevo después de {{resetAt}}.',
            forbidden: 'No tienes permiso para administrar publicaciones de esta organización.',
            notFound: 'No se encontró la organización o el trabajo de publicación.',
            conflict:
                'No se pudo completar esta solicitud de publicación debido a las restricciones de publicación actuales.',
            validation: {
                mediaUrlUnreachable:
                    'No se pudo acceder a la URL del medio. Proporciona un enlace directo y de acceso público a un archivo multimedia.',
                mediaUrlHttpError: 'La URL del medio respondió con un error en lugar de servir un archivo multimedia.',
                mediaUrlNotImage:
                    'Esta URL no apunta a un archivo de imagen. Enlaza directamente a una imagen (por ejemplo, una URL .jpg), no a una página web.',
                mediaUrlNotVideo:
                    'Esta URL no apunta a un archivo de vídeo. Enlaza directamente a un vídeo (por ejemplo, una URL .mp4), no a una página web.'
            }
        },
        oauthConsent: {
            loadFailed: 'No se pudo cargar la solicitud de consentimiento.',
            approveFailed: 'No se pudo aprobar la solicitud de consentimiento.',
            denyFailed: 'No se pudo denegar la solicitud de consentimiento.',
            invalidRequest: 'La solicitud de consentimiento es inválida.',
            forbidden: 'No tienes permiso para aprobar esta solicitud para la organización seleccionada.',
            notFound: 'Esta solicitud de consentimiento es desconocida, expiró o ya fue gestionada.'
        },
        insights: {
            loadFailed: 'No se pudieron cargar las estadísticas.',
            invalidQuery:
                'La consulta de estadísticas no es válida. Revisa la combinación de métrica, período y parámetros.',
            forbidden: 'No tienes permiso para ver las estadísticas de esta organización.',
            notFound: 'No se encontró la organización o la cuenta social.',
            notReadable:
                'Esta cuenta no puede ofrecer estadísticas en este momento. Vuelve a conectarla con el permiso de estadísticas.',
            providerRejected:
                'Instagram rechazó esta solicitud de estadísticas. Es posible que la combinación de métricas solicitada no sea compatible con esta cuenta.'
        }
    },
    validation: {}
} as const;
